import { SelectChangeEvent } from '@mui/material/Select';
import React from 'react';
import { useTheme } from 'styled-components';
import {
  Close,
  Expand,
  SelectDropdown as StyledSelectDropdown,
} from './SelectDropdown.styles';

export { SelectMenuItem } from './SelectDropdown.styles';

export type SelectDropdownProps = {
  children: React.ReactNode;
  onChange: (event: SelectChangeEvent<unknown>, child: React.ReactNode) => void;
  disabled?: boolean;
  placeholder?: string;
  defaultValue?: unknown;
  style?: React.CSSProperties;
  value?: string;
  className?: string;
  dataQa?: string;
};

const SelectDropdown = (props: SelectDropdownProps) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  return (
    <StyledSelectDropdown
      style={props.style}
      displayEmpty={!!props.placeholder}
      renderValue={(selected): React.ReactNode => {
        if (selected == null || selected === '') {
          return (props.placeholder ?? '') as React.ReactNode;
        }
        return selected as React.ReactNode;
      }}
      onClick={() => props.disabled !== true && setOpen(!open)}
      onChange={props.onChange}
      variant="standard"
      open={open}
      disabled={props.disabled}
      defaultValue={props.defaultValue}
      data-testid={props.dataQa}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        MenuListProps: {
          style: {
            border: `1px solid ${theme.atlas.semantic.color.action.primary.default}`,
            borderRadius: '0px 0px 5px 5px',
            padding: 0,
          },
        },
      }}
      IconComponent={() =>
        open ? (
          <Close onClick={() => !props.disabled && setOpen(!open)} />
        ) : (
          <Expand onClick={() => !props.disabled && setOpen(!open)} />
        )
      }
      className={props.className}
      value={props.value}
    >
      {props.children}
    </StyledSelectDropdown>
  );
};

export default SelectDropdown;
